import { defineComponent, resolveComponent, unref, ref, watch } from 'vue';import { useRouter } from 'vue-router';import { useStore } from 'vuex';import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-572bf8a5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer-content-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer_logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_3 = {
  class: "footer_wrap"
};
const _hoisted_4 = {
  class: "footer_left"
};
const _hoisted_5 = {
  class: "copyright-text"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "footer_right"
};
const _hoisted_8 = {
  class: "fr_item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "关于投资通", -1));
const _hoisted_10 = {
  class: "fr_item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "重要声明", -1));
const _hoisted_12 = {
  class: "fr_item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "投资者须知", -1));
import { useFun } from '@/hooks/useFun';
import { CompanyEnum } from '@/enums/appEnum';
import { useChannel } from '@/hooks/useChannel';
import { getSessionItem } from '@/utils/sessionstorage';
import moment from 'moment';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    year: null
  },
  setup(__props) {
    const props = __props;
    const police = ref('');
    police.value = require('@/assets/images/police.png');
    const router = useRouter();
    const {
      state
    } = useStore();
    // 路由跳转
    const toPage = urlName => {
      const routeUrl = router.resolve({
        name: urlName
      });
      window.open(routeUrl.href, '_blank');
    };
    // PDF跳转
    const {
      viewPDFPage
    } = useFun();
    // 链接跳转
    const toLink = url => {
      window.open(url, '_blank');
    };
    const {
      datangChannel
    } = useChannel();
    // 判断是否展示
    const isShow = () => {
      return !datangChannel();
    };
    // 根据服务器时间 获取年份
    const date = getSessionItem('zl-login-date');
    const showYear = ref(moment().format('YYYY'));
    if (date) {
      showYear.value = moment(date).format('YYYY');
    }
    watch(() => props.year, newVal => {
      if (newVal) {
        showYear.value = newVal;
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_svg_icon, {
        "icon-class": "address"
      }), _createTextVNode("公司地址：深圳市罗湖区笋岗街道笋西社区梨园路8号HALO广场一期四层12-13室 ")]), _createElementVNode("li", null, [_createVNode(_component_svg_icon, {
        "icon-class": "phone"
      }), _createTextVNode("客服热线：" + _toDisplayString(_unref(CompanyEnum).TELE) + "（工作日 9:00-18:30 ）", 1)]), _createElementVNode("li", null, [_createVNode(_component_svg_icon, {
        "icon-class": "email"
      }), _createTextVNode("客服邮箱：service@tzt.com.cn")]), _createElementVNode("li", null, [_createVNode(_component_svg_icon, {
        "icon-class": "fax"
      }), _createTextVNode("传真：0755-33227951")]), _createElementVNode("li", _hoisted_5, [_createVNode(_component_svg_icon, {
        "icon-class": "copyright"
      }), _createTextVNode(" Copyright © 2004-" + _toDisplayString(_unref(showYear)) + " 深圳众禄基金销售股份有限公司 ", 1), _createElementVNode("span", {
        class: "link",
        onClick: _cache[0] || (_cache[0] = $event => toLink('https://beian.miit.gov.cn/#/Integrated/recordQuery'))
      }, "粤ICP备09131572号"), _createTextVNode(" | "), _createElementVNode("img", {
        src: _unref(police),
        class: "police"
      }, null, 8, _hoisted_6), _createElementVNode("span", {
        class: "link",
        onClick: _cache[1] || (_cache[1] = $event => toLink('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030302002289'))
      }, "粤公网安备44030302002289号"), _createTextVNode(" ｜"), _createElementVNode("span", {
        class: "link",
        onClick: _cache[2] || (_cache[2] = $event => _unref(viewPDFPage)('免责声明'))
      }, "免责声明"), _createTextVNode(" ｜"), _createElementVNode("span", {
        class: "link",
        onClick: _cache[3] || (_cache[3] = $event => _unref(viewPDFPage)('隐私保护条款'))
      }, "隐私条款")])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, isShow() ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        link: "",
        onClick: _cache[4] || (_cache[4] = $event => toPage('about'))
      }, {
        default: _withCtx(() => [_createTextVNode("关于我们")]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        link: "",
        onClick: _cache[5] || (_cache[5] = $event => toPage('CertificateOfQualification'))
      }, {
        default: _withCtx(() => [_createTextVNode("资质证明")]),
        _: 1
      }), _createVNode(_component_el_button, {
        link: "",
        onClick: _cache[6] || (_cache[6] = $event => toPage('QualificationOfPersonnel'))
      }, {
        default: _withCtx(() => [_createTextVNode("人员资质")]),
        _: 1
      }), _createVNode(_component_el_button, {
        link: "",
        onClick: _cache[7] || (_cache[7] = $event => _unref(viewPDFPage)('投诉建议'))
      }, {
        default: _withCtx(() => [_createTextVNode("投诉建议")]),
        _: 1
      })]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_button, {
        link: "",
        onClick: _cache[8] || (_cache[8] = $event => toPage('SafetyGuidelines'))
      }, {
        default: _withCtx(() => [_createTextVNode("安全指引")]),
        _: 1
      }), _createVNode(_component_el_button, {
        link: "",
        onClick: _cache[9] || (_cache[9] = $event => toPage('LawsRegulations'))
      }, {
        default: _withCtx(() => [_createTextVNode("法律法规")]),
        _: 1
      }), _createVNode(_component_el_button, {
        link: "",
        onClick: _cache[10] || (_cache[10] = $event => _unref(viewPDFPage)('风险揭示书'))
      }, {
        default: _withCtx(() => [_createTextVNode("风险提示函")]),
        _: 1
      }), _createVNode(_component_el_button, {
        link: "",
        onClick: _cache[11] || (_cache[11] = $event => toPage('OpenList'))
      }, {
        default: _withCtx(() => [_createTextVNode("开户资料清单")]),
        _: 1
      })]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_el_button, {
        link: "",
        onClick: _cache[12] || (_cache[12] = $event => _unref(viewPDFPage)('投资者权益须知'))
      }, {
        default: _withCtx(() => [_createTextVNode("投资者权益须知")]),
        _: 1
      }), _createVNode(_component_el_button, {
        link: "",
        onClick: _cache[13] || (_cache[13] = $event => _unref(viewPDFPage)('投资者适当性管理制度'))
      }, {
        default: _withCtx(() => [_createTextVNode("投资者适当性管理制度")]),
        _: 1
      }), _createVNode(_component_el_button, {
        link: "",
        onClick: _cache[14] || (_cache[14] = $event => _unref(viewPDFPage)('基金产品风险等级评价管理办法'))
      }, {
        default: _withCtx(() => [_createTextVNode("基金产品风险等级评价管理办法")]),
        _: 1
      })])])])]);
    };
  }
});